<template>
  <div id="app">
    <div ref="homeApp" class="home-app">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div>
</template>
<script>
import { getTopBar } from "./common/js/flutterBrid";
export default {
  name: "App",
  created() {
    getTopBar((height) => {
      this.$refs.homeApp.style.top = height + "px";
    });
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("store", JSON.stringify(this.$store.state));
    });

    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem("store") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem("store"))
        )
      );
  },
  mounted () {
    this.watchAn()
  },
  methods: {
    watchAn () {
      var ua = window.navigator.userAgent.toLocaleLowerCase()
      var isAndroid = /android/.test(ua)
      var originHeight = document.documentElement.clientHeight || document.body.clientHeight
      window.addEventListener('resize', () => {
        if (isAndroid) {
          var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
          console.log(originHeight, resizeHeight)
          console.log('Android 键盘弹起啦！')
          if (originHeight > resizeHeight) { // 原来的高度 > 现在的高度 弹起来
            setTimeout(() => {
              document.activeElement.scrollIntoViewIfNeeded()
            }, 100)
          } else {
            console.log('Android 键盘收起啦！')
            setTimeout(() => {
              window.scrollTo(0, 0)
            }, 100)
          }
        }
      }, false)
    }
  }
};
</script>
<style lang="stylus" scoped>
#app {
  height: 100%;

  .home-app {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background: #F0F1F5;
    background-size: 100% auto;
  }
}
</style>
